import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/http';
import { Notice, errorMessage } from '../../components/common';
import { t } from '../../i18n';
import { StandingView, type Standing } from '../library/MyLibraryPage';

/** A parent's view of their child's library loans and fines. */
export function ChildLibrary({ studentId }: { studentId: string }) {
  const standing = useQuery({
    queryKey: ['me', 'children', studentId, 'library'],
    queryFn: () => api<Standing>(`/me/children/${studentId}/library`),
  });
  if (standing.isPending) return <p role="status">{t('common.loading')}</p>;
  if (standing.isError) return <Notice kind="error">{errorMessage(standing.error)}</Notice>;
  return <StandingView standing={standing.data} />;
}
